// extracted by mini-css-extract-plugin
module.exports = {"ProductList":"ProductList--32yIC","header":"header--jw2q7","headerLeft":"headerLeft--FaV3s","headerRight":"headerRight--flIq0","content":"content--3-EiD"};